import React from 'react';

const SYMBOL = { S: '♠', H: '♥', D: '♦', C: '♣' };
const COLOR  = { S: '#1a1a2e', H: '#dc2626', D: '#dc2626', C: '#1a1a2e' };
const LABEL  = (v) => v === 1 ? 'A' : v === 11 ? 'J' : v === 12 ? 'Q' : v === 13 ? 'K' : String(v);

export default function CardGraphic({ tile }) {
  if (!tile) return null;
  const { suit, value } = tile;
  const sym   = SYMBOL[suit] ?? suit;
  const color = COLOR[suit]  ?? '#1a1a2e';
  const label = LABEL(value);

  return (
    <svg viewBox="0 0 60 84" width="100%" height="100%"
         xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">

      {/* Card face */}
      <rect x="0.5" y="0.5" width="59" height="83" rx="5"
            fill="white" stroke="#cbd5e1" strokeWidth="1" />

      {/* Top-left — rank + suit, generously sized */}
      <text x="5" y="24"
            fontSize="24" fontWeight="900" fill={color}
            fontFamily="Georgia,'Times New Roman',serif"
            dominantBaseline="auto">{label}</text>
      <text x="5.5" y="44"
            fontSize="20" fill={color}
            fontFamily="Georgia,'Times New Roman',serif"
            dominantBaseline="auto">{sym}</text>

      {/* Large central pip — just right of centre, lower half */}
      <text x="36" y="64"
            textAnchor="middle" dominantBaseline="middle"
            fontSize="42" fill={color}
            fontFamily="Georgia,'Times New Roman',serif">{sym}</text>

    </svg>
  );
}
